import { Link } from 'react-router-dom'
import ReactPlayer from 'react-player/youtube'

export default function SlideOne() {
  return (
    <div className='slide slide-one'>
      <div className='container clearfix' style={{ textAlign: 'center' }}>
        <h1>
          <Link to='/closed-eye-visual'>
            CLOSED EYE VISUAL
          </Link>
        </h1>
        
        <div className='vid-wrapper'>
          <ReactPlayer
            title='culture hole'
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              margin: '0 auto',
              zIndex: 1
            }}
            height='80%'
            width='80%'
            url={ `https://www.youtube.com/embed/7PKyxIN1EDo` }
            config={{
              youtube: {
                playerVars: { 
                  showinfo: 0,
                  frameborder: 0,
                  controls: 1,
                  color: 'green',
                  modestbranding: 1
                }
              }
            }}/>
          
        </div>
      </div>
    </div>
  )
}
